import * as React from 'react';

import styles from './ai-loading-text.module.css';

export function AiLoadingText() {
    return <div className={styles['ai-loading-text']} />;
}
